
const SUPER_CHEAP_AUTO_AU = 'AU_SCA';

const getStore = () => TYROOLA
    && Object.prototype.hasOwnProperty.call(TYROOLA, 'globals')
    && TYROOLA.globals.store;

export const is_AU_SCA = () => {
    return getStore() === SUPER_CHEAP_AUTO_AU;
};

export default (store) => {
    return getStore() === store;
};